import { render, staticRenderFns } from "./NotificationsExplorer.vue?vue&type=template&id=206db0c7&scoped=true&"
import script from "./NotificationsExplorer.vue?vue&type=script&lang=js&"
export * from "./NotificationsExplorer.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsExplorer.vue?vue&type=style&index=0&id=206db0c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206db0c7",
  null
  
)

export default component.exports